import * as routes from 'pages/routes';
import * as companyApi from 'resources/company/company.api';
import * as companyEventsApi from 'resources/company-events/company-events.api';
import * as companyResource from 'resources/company/hooks';
import * as companyHelpers from 'resources/company/company.helpers';
import { SUBSCRIPTION_PLANS } from 'resources/company/company.constants';
import uiNotifications from 'services/uiNotification.service';


export default function useSubscribe() {
  const { company } = companyResource.useCurrentCompany();

  const subscribe = async () => {
    if (companyHelpers.isSubscribed(company)) {
      uiNotifications.showSuccess('You are already subscribed to a plan. Refresh the page to see changes.');
      return;
    }

    try {
      const { url } = await companyApi.createSubscriptionCheckoutSession(`${routes.path.account}/?tab=billing`, SUBSCRIPTION_PLANS.GROW.PRICE_ID, window?.promotekit_referral);
      const checkoutWindow = window.open(url);
      if (!checkoutWindow) {
        uiNotifications.showError('Subscription popup blocked. Please allow popups in your browser and try again.', { duration: 10});
      } else {
        trackSubscribeEvent(company);
      }
    } catch (error) {
      console.error('Error creating subscription checkout session:', error);
      uiNotifications.showError('Failed to initiate subscription process. Please try again.');
    }
  };

  const trackSubscribeEvent = (company) => {
    try {
      // Track subscribe attempt only for companies that never subscribed before
      if (!companyHelpers.wasNeverSubscribed(company)) {
        return;
      }

      companyEventsApi.create('trial_initiated_subscription');
    } catch (error) {
      // do not block the main flow if tracking fails
      console.error('Error tracking subscribe event:', error);
    }
  };

  return {
    subscribe,
  };
}